import { Box, Text } from '@chakra-ui/react'
import React from 'react'

export interface NodeLabelProps {
  /** Label text to display */
  label: string
  /** Whether the field is required (shows asterisk) */
  required?: boolean
}

/**
 * Standardized floating label component for switchboard node inputs
 * Label appears on the border with a seamless "no background" effect
 * Top half matches panel background, bottom half matches input interior
 */
export const NodeLabel: React.FC<NodeLabelProps> = ({
  label,
  required = false,
}) => {
  return (
    <Box
      as="label"
      position="absolute"
      top="-8px"
      left="8px"
      fontSize="11px"
      fontWeight="500"
      color="fg.muted"
      px={1}
      pointerEvents="none"
      whiteSpace="nowrap"
      zIndex={1}
      lineHeight="1.2"
      height="16px"
    >
      {/* Top half background - matches panel (above border) */}
      <Box position="absolute" bg="bg.muted" zIndex={-1} />
      {/* Bottom half background - matches input interior (below border) */}
      <Box
        position="absolute"
        top="8px"
        left="2px"
        right="2px"
        bottom={0}
        bg="bg.panel"
        zIndex={-1}
      />
      {/* Label text */}
      <Box position="relative" mt={'2px'} zIndex={1}>
        {label}
        {required && (
          <Text as="span" color="fg.error" ml={0.5}>
            *
          </Text>
        )}
      </Box>
    </Box>
  )
}
